import { request } from '@langlois/request';

export async function updateEvent ({ commit, dispatch }, event) {
	try {
		const url = new URL(`${process.env.VUE_APP_API_URI}/club/competition-event/${event.id}`);

		const response = await request.patch(url, event);

		if (response.ok) {
			dispatch(`closeForm`);

			return commit(`updateEvent`, event);
		}

		return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while updating the event.`,
			type: `warning`
		}, { root: true });
	} catch (e) {
		return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while updating the event.`,
			type: `warning`
		}, { root: true });
	}
}
